import {ReactComponent} from "./arrow-down-line.svg";

interface Props {
    fill?: string;
    width?: string;
    height?: string;
}

const ArrowDownLineIcon: React.FC<Props> = (props) => (
    <ReactComponent {...props} />
);

export default ArrowDownLineIcon;
